import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
  export default new Vuex.Store({
    state: {
      // 要回显的数据
      imgUrl:'https://bzshjt.com/webpic/',// https://bzshjt.com/ https://hbrsyyyxgs.com http://www.shenhaoyaoye.com http://xiangzhiyaoye.com  http://ysxyygs.com/元氏 http://hbqsyy.cn河北强盛药业集团有限公司
      logoImg:'https://bzshjt.com/',
      companyID:10,//神豪5 荣顺12 祥芝10 元氏25 三亚10 亳州市厚济堂药业有限公司 河北安国振宇药业有限公司10
      lunboList:[],
      gongsijianjie:'',
      gongsipic:'',
      productList:[],
      companypic:{},
      companyName:'亳州市厚济堂药业有限公司',
      quanming:'亳州市厚济堂药业有限公司',
      appName:'厚济堂药业',
      logo:'',
      footerInfo:{},
      addresscoordinate:''
    },
    getters: {
    },
    mutations: {
      CHANGE_imgUrl: (state, imgUrl) => state.imgUrl =imgUrl,
      CHANGE_logoImg: (state, logoImg) => state.logoImg =logoImg,
        CHANGE_ADDRESSCOORDINATE: (state, addresscoordinate) => state.addresscoordinate = addresscoordinate,
      CHANGE_LUNboList: (state, lunbolist) => state.lunboList = lunbolist,
      CHANGE_LOGO: (state, logo) => state.logo =logo,

      CHANGE_GONGSIJIANJIE: (state, JIANJIE) => state.gongsijianjie = JIANJIE,
      CHANGE_GONGSIPIC: (state, gongsipic) => state.gongsipic = gongsipic,
      CHANGE_PRODUCTLIST: (state, productList) => state.productList = productList,
      CHANGE_COMPANYPIC: (state, companypic) => state.companypic = companypic,
      CHANGE_footerInfo: (state, footerInfo) => state.footerInfo = footerInfo,

    },
    actions: {
    },
    modules: {
    }
  })




// WEBPACK FOOTER //
// ./src/store/index.js